import { useMemo } from 'react'
import type { ColDef } from 'ag-grid-community'
import type { CustomCellRendererProps } from 'ag-grid-react'
import { Badge } from '@/components/ui/badge'
import { DataGrid, GridTextCell } from '@/components/common/grid'
import type { StoreRead } from '@/types'

function ActiveBadgeCell(props: CustomCellRendererProps<StoreRead>) {
  const isActive = props.value as boolean

  return (
    <Badge variant={isActive ? 'success' : 'warning'}>
      {isActive ? 'Active' : 'Inactive'}
    </Badge>
  )
}

interface StoresGridProps {
  stores: StoreRead[]
  loading?: boolean
}

export function StoresGrid({ stores, loading }: StoresGridProps) {
  const columnDefs: ColDef<StoreRead>[] = useMemo(
    () => [
      {
        field: 'store_number',
        headerName: 'Store #',
        flex: 1,
        minWidth: 100,
        maxWidth: 130,
        cellRenderer: GridTextCell,
      },
      {
        field: 'name',
        headerName: 'Name',
        flex: 2,
        minWidth: 180,
        cellRenderer: GridTextCell,
      },
      {
        field: 'region',
        headerName: 'Region',
        flex: 1,
        minWidth: 100,
        maxWidth: 140,
        cellRenderer: GridTextCell,
      },
      {
        field: 'district',
        headerName: 'District',
        flex: 1,
        minWidth: 100,
        maxWidth: 140,
        cellRenderer: GridTextCell,
      },
      {
        field: 'is_active',
        headerName: 'Active',
        flex: 1,
        minWidth: 100,
        maxWidth: 120,
        cellRenderer: ActiveBadgeCell,
      },
    ],
    []
  )

  return (
    <DataGrid
      rowData={stores}
      columnDefs={columnDefs}
      loading={loading}
      noRowsMessage="No stores found"
    />
  )
}
